import { useParams } from 'react-router-dom';

import { AppTabsSettingsPage } from '~/components/pages/AppTabsSettingsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppTabsSettingsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppTabsSettingsPage appId={appId} />
    </DashboardTemplate>
  );
};
